import { FC, PropsWithChildren } from 'react'
import type { HAST, MDAST } from '@stoplight/markdown'
import { DefaultSMDComponents } from '@stoplight/elements-core'

import { HttpRequestComponent } from './HttpRequestComponent'
import { MarkdownViewerProvider as MarkdownProvider } from '@stoplight/markdown-viewer'
import { JsonSchemaComponent } from './JsonSchemaComponent'

type MarkdownCodeProps = Pick<MDAST.Code, 'lang' | 'resolved'> &
  HAST.CodeProperties

export const MarkdownViewerProvider: FC = ({ children }) => (
  <MarkdownProvider
    mermaidScriptUrl={`${process.env.PUBLIC_URL}/vendors/mermaid.min.js`}
    components={{
      code: (props: PropsWithChildren<MarkdownCodeProps>) => {
        const { lang, children } = props

        if (lang === 'httpRequest' || lang === 'jsonSchema') {
          const value = String(Array.isArray(children) ? children[0] : children)

          return lang === 'httpRequest' ? (
            <HttpRequestComponent value={value} />
          ) : (
            <JsonSchemaComponent value={value} />
          )
        }

        const DefaultCode = DefaultSMDComponents.code!
        return <DefaultCode {...props} />
      },
    }}
  >
    {children}
  </MarkdownProvider>
)
